import { TenantDto } from '@bo-client/shared/models/tenantDto';
import { EntityModel } from '@bo-client/shared/models/entityModel';
import { ResponsiblePartyEnum } from '@bo-client/shared/models/next-actions.dto';

export class RequestModel extends EntityModel {
  id: number | null = null;
  referenceId?: string | null = null;
  state: string = BaseStatusEnum.Incomplete;
  createdDate?: Date | string;
  modifiedDate?: Date | string;
  stateModifiedDate: Date | string;
  createdBy?: string;
  lastModifiedBy?: string;
  version?: number;
  tenant?: TenantDto;
  // NextActions

  // Feedback-Kommentar-Felders
  networkOperatorFeedbackComment?: string;
  installerFeedbackComment?: string;
  feedbackRequestedDate?: Date | string;
  feedbackRequestedBy?: string;

  nextActionType?: string;
  responsibleParty?: ResponsiblePartyEnum;
}

export enum BaseStatusEnum {
  Incomplete = 'Incomplete'
}
